import { render, staticRenderFns } from "./net-sales.vue?vue&type=template&id=37a20b1a&scoped=true&"
import script from "./net-sales.vue?vue&type=script&lang=js&"
export * from "./net-sales.vue?vue&type=script&lang=js&"
import style0 from "./net-sales.vue?vue&type=style&index=0&id=37a20b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a20b1a",
  null
  
)

export default component.exports